import { router } from '@/app/router'
import { GlobalProvider } from '@/entities'
import { tenantConfig } from '@/shared/config/tenant'
import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'

function App() {
    useEffect(() => {
        if (tenantConfig.name?.title) {
            document.title = tenantConfig.name.title
        }

        if (tenantConfig.description) {
            const meta = document.createElement('meta')
            meta.name = 'description'
            meta.content = tenantConfig.description
            document.head.appendChild(meta)
        }

        if (tenantConfig.favicon_url) {
            const link = document.createElement('link')
            link.rel = 'icon'
            link.href = tenantConfig.favicon_url
            document.head.appendChild(link)
        }
    }, [])

    return (
        <GlobalProvider>
            <RouterProvider router={router} />
        </GlobalProvider>
    )
}

export default App
